<template>
  <div class="footer-widget">
    <h4 class="footer-widget__title">{{ title }}</h4>
    <ul class="footer-widget__navigation">
      <li v-for="list in nav" :key="list.id">
        <router-link :to="menuItemLink(list)">{{ list.name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["title", "nav"],
  methods: {
    menuItemLink(item) {
      if (item.type == "internal_link") {
        return item.link
      }
      return "#"
    },
  },
}
</script>

<style lang="scss"></style>
